<div>
  <input type="number"
        [formControl]="numberPercentageFormControl"
        class="form-control"
        autocomplete="off"
        [formlyAttributes]="field"
        [class.is-invalid]="showError">
  <span>%</span>
</div>
